- section: Skills
  items:

    - id: ele-summon-dps
      text: ''
      subText: Total Flat Summon Damage (no modifiers)
      amountData:
        label: 'dps'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Flat DPS: 1
      temporaryBuff: true

    - id: signet-of-fire
      text: Signet of Fire
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Precision: [180, buff]
      gw2id: 5542
      temporaryBuff: activeOutOfCombat

    - id: signet-of-earth
      text: Signet of Earth
      subText: damage reduction (tooltip is incorrect)
      modifiers:
        damage:
          Damage Reduction: [10%, unknown]
      gw2id: 5571

    - id: signet-of-earth-bug
      text: Signet of Earth
      subText: 'bug: toughness from activation w/ trait'
      modifiers:
        attributes:
          Toughness: [180, buff]
      gw2id: 5571
      temporaryBuff: true

    - id: woven-fire
      text: Woven Fire
      subText: woven fire / perfect weave
      amountData:
        label: '% uptime'
        default: 38
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Condition Damage: [20%, add]
      gw2id: 43638

    - id: woven-air
      text: Woven Air
      subText: woven air / perfect weave
      amountData:
        label: '% uptime'
        default: 36
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
      gw2id: 43638

    - id: flame-wheel
      text: Flame Wheel
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      gw2id: 62758

    - id: crescent-wind
      text: Crescent Wind
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Critical Chance: 15%
      wvwModifiers:
        attributes:
          Critical Chance: 12%
      gw2id: 62887
      temporaryBuff: true

    - id: rocky-loop
      text: Rocky Loop
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [15%, mult]
      wvwModifiers:
        damage:
          Damage Reduction: [10%, mult]
      gw2id: 62975

    - id: relentless-fire
      text: Relentless Fire
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      gw2id: 62965

    # like life steal: unaffected by opponent armor, player weapon strength, vulnerability, etc.
    # use EI buff uptime rather than EI hit count; it seems more accurate
    - id: fulgor-ticks
      text: Fulgor
      subText: damage over time effect
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        attributes:
          Flat DPS: 200
        conversionAfterBuffs:
          Flat DPS: {Power: 40%}
      wvwModifiers:
        attributes:
          Power Coefficient: 0.4
          Flat DPS: 160
        conversionAfterBuffs:
          Flat DPS: {Power: 15%}
      gw2id: 73091
      temporaryBuff: true

    - id: grinding-stones
      text: Grinding Stones
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [25%, mult]
      gw2id: 40963

    - id: woven-earth
      text: Woven Earth
      subText: damage reduction while earth active
      modifiers:
        damage:
          Damage Reduction: [20%, mult]
      gw2id: 43638

    # - id: flame-axe
    #   text: Flame Axe
    #   subText: when equipped
    #   modifiers:
    #     attributes:
    #       Power: [180, buff]
    #       Condition Damage: [180, buff]
    #   gw2id: 5540

    # - id: earth-shield
    #   text: Earth Shield
    #   subText: when equipped
    #   modifiers:
    #     attributes:
    #       Vitality: [180, buff]
    #       Toughness: [180, buff]
    #   gw2id: 5546

    # - id: fiery-greatsword
    #   text: Fiery Greatsword
    #   subText: when equipped
    #   modifiers:
    #     attributes:
    #       Power: [260, buff]
    #       Condition Damage: [180, buff]
    #   gw2id: 5516

    - id: lightning-hammer
      text: Lightning Hammer
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Precision: [180, buff]
          Ferocity: [75, buff]
      gw2id: 5624
      temporaryBuff: true

    # - id: frost-bow
    #   text: Frost Bow
    #   subText: when equipped
    #   modifiers:
    #     attributes:
    #       Healing Power: [180, buff]
    #       Condition Duration: 20%
    #   gw2id: 5567

- section: Fire
  id: 31
  items:

    - id: empowering-flame
      text: Empowering Flame
      minor: true
      amountData:
        label: '% fire attunement'
        default: 50
        quantityEntered: 100
      modifiers:
        attributes:
          Power: [150, buff]
      gw2id: 320
      defaultEnabled: true
      temporaryBuff: activeOutOfCombat # assume the user is in fire attunement, not air

    - id: burning-precision
      text: Burning Precision
      subText: base
      modifiers:
        attributes:
          Burning Duration: 20%
      wvwModifiers:
        attributes:
          Burning Duration: 15%
      gw2id: 296
      defaultEnabled: true
      temporaryBuff: false

    # - id: burning-precision-on-crit
    #   text: Burning Precision
    #   amountData:
    #     label: '/10s'
    #     default: 1.9
    #     quantityEntered: 10
    #   modifiers:
    #     attributes:
    #       Burning Coefficient: 3
    #   gw2id: 296
    #   defaultEnabled: false

    - id: burning-rage
      text: Burning Rage
      modifiers:
        attributes:
          Condition Damage: [180, buff]
      gw2id: 325
      defaultEnabled: true
      temporaryBuff: false

    - id: power-overwhelming
      text: Power Overwhelming
      subText: permanent
      modifiers:
        attributes:
          Power: [150, buff]
      gw2id: 334
      defaultEnabled: true
      temporaryBuff: false

    - id: power-overwhelming-2
      text: Power Overwhelming
      amountData:
        label: '% fire attunement'
        default: 50
        quantityEntered: 100
      modifiers:
        attributes:
          Power: [150, buff]
      gw2id: 334
      defaultEnabled: true
      temporaryBuff: activeOutOfCombat # assume the user is in fire attunement, not air

    - id: pyromancers-training
      text: Pyromancer's Training
      minor: true
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 319
      defaultEnabled: true

    - id: persisting-flames
      text: Persisting Flames
      amountData:
        label: 'stacks'
        default: 5
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [2%, add]
      gw2id: 1510
      defaultEnabled: true

    - id: inferno
      text: Inferno
      modifiers:
        calculationTweaks:
          infernoBurningDamage: true
      gw2id: 1675
      defaultEnabled: true

- section: Air
  id: 41
  items:

    - id: zephyrs-speed
      text: Zephyr's Speed
      minor: true
      modifiers:
        attributes:
          Critical Chance: 5%
      gw2id: 221
      defaultEnabled: true
      temporaryBuff: false

    - id: ferocious-winds
      text: Ferocious Winds
      modifiers:
        conversion:
          Ferocity: {Precision: 7%}
      gw2id: 232
      defaultEnabled: true
      temporaryBuff: false

    - id: raging-storm
      text: Raging Storm
      amountData:
        label: '% fury'
        default: 100
        quantityEntered: 100
      modifiers:
        attributes:
          Ferocity: [180, buff]
      gw2id: 214
      defaultEnabled: true
      temporaryBuff: true

    - id: stormsoul
      text: Stormsoul
      subText: disabled/defiant
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 1502
      defaultEnabled: true

    - id: aeromancers-training
      text: Aeromancer's Training
      subText: permanent
      minor: true
      modifiers:
        attributes:
          Ferocity: [150, buff]
      gw2id: 223
      defaultEnabled: true
      temporaryBuff: false

    - id: aeromancers-training-2
      text: Aeromancer's Training
      amountData:
        label: '% air attunement'
        default: 50
        quantityEntered: 100
      minor: true
      modifiers:
        attributes:
          Ferocity: [150, buff]
      gw2id: 223
      defaultEnabled: true
      temporaryBuff: true # assume the user is in fire attunement, not air

    - id: bolt-to-the-heart
      text: Bolt to the Heart
      amountData:
        label: '% below 50'
        default: 50
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [20%, mult]
      gw2id: 226
      defaultEnabled: true

    - id: fresh-air
      text: Fresh Air
      amountData:
        label: '% uptime'
        default: 50
        quantityEntered: 100
      modifiers:
        attributes:
          Ferocity: [250, buff]
      gw2id: 1503
      defaultEnabled: true
      temporaryBuff: true

- section: Earth
  id: 26
  items:

    - id: stone-flesh
      text: Stone Flesh
      minor: true
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [7%, unknown]
      gw2id: 278
      defaultEnabled: false

    - id: serrated-stones
      text: Serrated Stones
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
        attributes:
          Bleeding Duration: 20%
      gw2id: 1507
      defaultEnabled: true
      temporaryBuff: false

    - id: strength-of-stone
      text: Strength of Stone
      modifiers:
        conversion:
          Condition Damage: {Toughness: 10%}
      gw2id: 275
      defaultEnabled: true
      temporaryBuff: false

    - id: geomancers-training
      text: Geomancer's Training
      minor: true
      modifiers:
        damage:
          Damage Reduction: [10%, unknown]
      gw2id: 280
      defaultEnabled: true

    - id: stone-heart
      text: Stone Heart
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [0%, mult] # todo: unknown
      gw2id: 1674
      defaultEnabled: false

- section: Water
  id: 17
  items:

    - id: piercing-shards
      text: Piercing Shards
      subText: base
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
      gw2id: 363
      defaultEnabled: true

    - id: piercing-shards-2
      text: Piercing Shards
      amountData:
        label: '% water attunement'
        default: 5
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
      gw2id: 363
      defaultEnabled: true

    - id: flow-like-water-low
      text: Flow like Water
      subText: 'low health'
      amountData:
        label: '% uptime'
        default: 0
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
      gw2id: 349
      defaultEnabled: false

    - id: flow-like-water
      text: Flow like Water
      subText: 'high health'
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 349
      defaultEnabled: true

    - id: aquamancers-training
      text: Aquamancer's Training
      modifiers:
        attributes:
          Outgoing Healing: 20%
      minor: true
      gw2id: 1676
      defaultEnabled: true
      temporaryBuff: false

    - id: soothing-power
      text: Soothing Power
      modifiers:
        attributes:
          Vitality: [300, buff]
      gw2id: 2028
      defaultEnabled: true
      temporaryBuff: false

- section: Arcane
  id: 37
  items:

    - id: elemental-enchantment
      text: Elemental Enchantment
      modifiers:
        attributes:
          Concentration: [180, buff]
      wvwModifiers:
        attributes:
          Concentration: [120, buff]
      minor: true
      gw2id: 2004
      defaultEnabled: true
      temporaryBuff: false

    - id: arcane-lightning
      text: Arcane Lightning
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        attributes:
          Ferocity: [150, converted]
      gw2id: 263
      defaultEnabled: true
      temporaryBuff: true

    - id: bountiful-power
      text: Bountiful Power
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [20%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [15%, add]
      gw2id: 1511
      defaultEnabled: true

- section: Tempest
  id: 48
  items:

    - id: gathered-focus
      text: Gathered Focus
      subText: base amount
      modifiers:
        attributes:
          Concentration: [240, buff]
      wvwModifiers:
        attributes:
          Concentration: [120, buff] #it would be an additional 60 if above 90% hp. But i dont want to asume that in a wvw setting, so i go with the lower one in case i want to optimize for boon duration
      minor: true
      gw2id: 1938
      defaultEnabled: true
      temporaryBuff: false

    - id: hardy-conduit
      text: Hardy Conduit
      minor: true
      modifiers:
        damage:
          Damage Reduction: [6.6%, unknown]
      gw2id: 1948
      defaultEnabled: true

    - id: transcendent-tempest
      text: Transcendent Tempest
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add]
          Outgoing Condition Damage: [20%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, add]
          Outgoing Condition Damage: [7%, add]
      gw2id: 1839
      defaultEnabled: true

    - id: tempestuous-aria
      text: Tempestuous Aria
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add] # per Crone
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, add] # per Crone
          Outgoing Condition Damage: [7%, add]
      gw2id: 1891
      defaultEnabled: true

- section: Weaver
  id: 56
  items:

    - id: superior-elements
      text: Superior Elements
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Critical Chance: 15%
      wvwModifiers:
        attributes:
          Critical Chance: 15%
      gw2id: 2177
      defaultEnabled: true
      temporaryBuff: true

    - id: masters-fortitude
      text: Master's Fortitude
      subText: base
      modifiers:
        conversion:
          Vitality: {Power: 5%, Condition Damage: 5%}
      gw2id: 2115
      defaultEnabled: true
      temporaryBuff: false

    - id: masters-fortitude-sword
      text: Master's Fortitude
      subText: with sword
      modifiers:
        attributes:
          Vitality: [120, converted]
      gw2id: 2115
      defaultEnabled: true
      temporaryBuff: false # since you only have one weapon set

    - id: weavers-prowess
      text: Weaver's Prowess
      subText: 100% uptime
      modifiers:
        attributes:
          Condition Duration: 20%
      wvwModifiers:
        attributes:
          Condition Duration: 7%
      gw2id: 2180
      defaultEnabled: true
      temporaryBuff: true

    - id: swift-revenge
      text: Swift Revenge
      amountData:
        label: '% swiftness'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
      gw2id: 2061
      defaultEnabled: true

    - id: elemental-polyphony-fire
      text: Elemental Polyphony
      minor: true
      amountData:
        label: '% fire attunement'
        default: 50
        quantityEntered: 100
      modifiers:
        attributes:
          Power: [200, buff]
      wvwModifiers:
        attributes:
          Power: [120, buff]
      gw2id: 2081
      defaultEnabled: true
      temporaryBuff: activeOutOfCombat # assume the user is in fire attunement, not air

    - id: elemental-polyphony-air
      text: Elemental Polyphony
      minor: true
      amountData:
        label: '% air attunement'
        default: 50
        quantityEntered: 100
      modifiers:
        attributes:
          Ferocity: [200, buff]
      wvwModifiers:
        attributes:
          Ferocity: [120, buff]
      gw2id: 2081
      defaultEnabled: true
      temporaryBuff: true # assume the user is in fire attunement, not air

    - id: elements-of-rage-base
      text: Elements of Rage
      subText: base
      modifiers:
        conversion:
          Precision: {Vitality: 13%}
      gw2id: 2131
      defaultEnabled: true
      temporaryBuff: false

    - id: elements-of-rage-buff
      text: Elements of Rage
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Condition Damage: [5%, add]
          Outgoing Strike Damage: [7%, add] # untested; please confirm!
      wvwModifiers:
        damage:
          Outgoing Condition Damage: [5%, add]
          Outgoing Strike Damage: [5%, add] # untested; please confirm!
      gw2id: 2131
      defaultEnabled: true

- section: Catalyst
  id: 67
  note: Enter identical uptimes for "regular" Elemental Empowerment and Empowered Empowerment, if
    applicable.
  items:

    - id: hardened-auras
      text: Hardened Auras
      amountData:
        label: 'stacks'
        default: 5
        quantityEntered: 1
        disableBlacklist: true
      modifiers:
        damage:
          Damage Reduction: [2%, unknown]
      gw2id: 2230
      defaultEnabled: true

    - id: elemental-empowerment-1
      text: Elemental Empowerment
      subText: 1 stack
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '1'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 1%}
          Precision: {Precision: 1%}
          Toughness: {Toughness: 1%}
          Vitality: {Vitality: 1%}
          Concentration: {Concentration: 1%}
          Condition Damage: {Condition Damage: 1%}
          Expertise: {Expertise: 1%}
          Ferocity: {Ferocity: 1%}
          Healing Power: {Healing Power: 1%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-2
      text: Elemental Empowerment
      subText: 2 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '2'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 2%}
          Precision: {Precision: 2%}
          Toughness: {Toughness: 2%}
          Vitality: {Vitality: 2%}
          Concentration: {Concentration: 2%}
          Condition Damage: {Condition Damage: 2%}
          Expertise: {Expertise: 2%}
          Ferocity: {Ferocity: 2%}
          Healing Power: {Healing Power: 2%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-3
      text: Elemental Empowerment
      subText: 3 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '3'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 3%}
          Precision: {Precision: 3%}
          Toughness: {Toughness: 3%}
          Vitality: {Vitality: 3%}
          Concentration: {Concentration: 3%}
          Condition Damage: {Condition Damage: 3%}
          Expertise: {Expertise: 3%}
          Ferocity: {Ferocity: 3%}
          Healing Power: {Healing Power: 3%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-4
      text: Elemental Empowerment
      subText: 4 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '4'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 4%}
          Precision: {Precision: 4%}
          Toughness: {Toughness: 4%}
          Vitality: {Vitality: 4%}
          Concentration: {Concentration: 4%}
          Condition Damage: {Condition Damage: 4%}
          Expertise: {Expertise: 4%}
          Ferocity: {Ferocity: 4%}
          Healing Power: {Healing Power: 4%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-5
      text: Elemental Empowerment
      subText: 5 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '5'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 5%}
          Precision: {Precision: 5%}
          Toughness: {Toughness: 5%}
          Vitality: {Vitality: 5%}
          Concentration: {Concentration: 5%}
          Condition Damage: {Condition Damage: 5%}
          Expertise: {Expertise: 5%}
          Ferocity: {Ferocity: 5%}
          Healing Power: {Healing Power: 5%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-6
      text: Elemental Empowerment
      subText: 6 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '6'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 6%}
          Precision: {Precision: 6%}
          Toughness: {Toughness: 6%}
          Vitality: {Vitality: 6%}
          Concentration: {Concentration: 6%}
          Condition Damage: {Condition Damage: 6%}
          Expertise: {Expertise: 6%}
          Ferocity: {Ferocity: 6%}
          Healing Power: {Healing Power: 6%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-7
      text: Elemental Empowerment
      subText: 7 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '7'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 7%}
          Precision: {Precision: 7%}
          Toughness: {Toughness: 7%}
          Vitality: {Vitality: 7%}
          Concentration: {Concentration: 7%}
          Condition Damage: {Condition Damage: 7%}
          Expertise: {Expertise: 7%}
          Ferocity: {Ferocity: 7%}
          Healing Power: {Healing Power: 7%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-8
      text: Elemental Empowerment
      subText: 8 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '8'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 8%}
          Precision: {Precision: 8%}
          Toughness: {Toughness: 8%}
          Vitality: {Vitality: 8%}
          Concentration: {Concentration: 8%}
          Condition Damage: {Condition Damage: 8%}
          Expertise: {Expertise: 8%}
          Ferocity: {Ferocity: 8%}
          Healing Power: {Healing Power: 8%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-9
      text: Elemental Empowerment
      subText: 9 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '9'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 9%}
          Precision: {Precision: 9%}
          Toughness: {Toughness: 9%}
          Vitality: {Vitality: 9%}
          Concentration: {Concentration: 9%}
          Condition Damage: {Condition Damage: 9%}
          Expertise: {Expertise: 9%}
          Ferocity: {Ferocity: 9%}
          Healing Power: {Healing Power: 9%}
      gw2id: 2250
      defaultEnabled: false
      temporaryBuff: true

    - id: elemental-empowerment-10
      text: Elemental Empowerment
      subText: 10 stacks
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '10'
      minor: true
      modifiers:
        conversion:
          Power: {Power: 10%}
          Precision: {Precision: 10%}
          Toughness: {Toughness: 10%}
          Vitality: {Vitality: 10%}
          Concentration: {Concentration: 10%}
          Condition Damage: {Condition Damage: 10%}
          Expertise: {Expertise: 10%}
          Ferocity: {Ferocity: 10%}
          Healing Power: {Healing Power: 10%}
      gw2id: 2250
      defaultEnabled: true
      temporaryBuff: true

    - id: empowering-auras
      text: Empowering Auras
      amountData:
        label: 'stacks'
        default: 2
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [1%, add] # per Crone
          Outgoing Condition Damage: [1%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [1%, add] # per Crone
          Outgoing Condition Damage: [1%, add]
      gw2id: 2247
      defaultEnabled: true

    - id: spectacular-sphere
      text: Spectacular Sphere
      modifiers: {}
      wvwModifiers: {}
      gw2id: 2234
      defaultEnabled: true

    - id: empowered-empowerment-1
      text: Empowered Empowerment
      subText: 1 stack
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '1'
      modifiers:
        conversion:
          Power: {Power: 0.5%}
          Precision: {Precision: 0.5%}
          Toughness: {Toughness: 0.5%}
          Vitality: {Vitality: 0.5%}
          Concentration: {Concentration: 0.5%}
          Condition Damage: {Condition Damage: 0.5%}
          Expertise: {Expertise: 0.5%}
          Ferocity: {Ferocity: 0.5%}
          Healing Power: {Healing Power: 0.5%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-2
      text: Empowered Empowerment
      subText: 2 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '2'
      modifiers:
        conversion:
          Power: {Power: 1%}
          Precision: {Precision: 1%}
          Toughness: {Toughness: 1%}
          Vitality: {Vitality: 1%}
          Concentration: {Concentration: 1%}
          Condition Damage: {Condition Damage: 1%}
          Expertise: {Expertise: 1%}
          Ferocity: {Ferocity: 1%}
          Healing Power: {Healing Power: 1%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-3
      text: Empowered Empowerment
      subText: 3 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '3'
      modifiers:
        conversion:
          Power: {Power: 1.5%}
          Precision: {Precision: 1.5%}
          Toughness: {Toughness: 1.5%}
          Vitality: {Vitality: 1.5%}
          Concentration: {Concentration: 1.5%}
          Condition Damage: {Condition Damage: 1.5%}
          Expertise: {Expertise: 1.5%}
          Ferocity: {Ferocity: 1.5%}
          Healing Power: {Healing Power: 1.5%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-4
      text: Empowered Empowerment
      subText: 4 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '4'
      modifiers:
        conversion:
          Power: {Power: 2%}
          Precision: {Precision: 2%}
          Toughness: {Toughness: 2%}
          Vitality: {Vitality: 2%}
          Concentration: {Concentration: 2%}
          Condition Damage: {Condition Damage: 2%}
          Expertise: {Expertise: 2%}
          Ferocity: {Ferocity: 2%}
          Healing Power: {Healing Power: 2%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-5
      text: Empowered Empowerment
      subText: 5 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '5'
      modifiers:
        conversion:
          Power: {Power: 2.5%}
          Precision: {Precision: 2.5%}
          Toughness: {Toughness: 2.5%}
          Vitality: {Vitality: 2.5%}
          Concentration: {Concentration: 2.5%}
          Condition Damage: {Condition Damage: 2.5%}
          Expertise: {Expertise: 2.5%}
          Ferocity: {Ferocity: 2.5%}
          Healing Power: {Healing Power: 2.5%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-6
      text: Empowered Empowerment
      subText: 6 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '6'
      modifiers:
        conversion:
          Power: {Power: 3%}
          Precision: {Precision: 3%}
          Toughness: {Toughness: 3%}
          Vitality: {Vitality: 3%}
          Concentration: {Concentration: 3%}
          Condition Damage: {Condition Damage: 3%}
          Expertise: {Expertise: 3%}
          Ferocity: {Ferocity: 3%}
          Healing Power: {Healing Power: 3%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-7
      text: Empowered Empowerment
      subText: 7 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '7'
      modifiers:
        conversion:
          Power: {Power: 3.5%}
          Precision: {Precision: 3.5%}
          Toughness: {Toughness: 3.5%}
          Vitality: {Vitality: 3.5%}
          Concentration: {Concentration: 3.5%}
          Condition Damage: {Condition Damage: 3.5%}
          Expertise: {Expertise: 3.5%}
          Ferocity: {Ferocity: 3.5%}
          Healing Power: {Healing Power: 3.5%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-8
      text: Empowered Empowerment
      subText: 8 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '8'
      modifiers:
        conversion:
          Power: {Power: 4%}
          Precision: {Precision: 4%}
          Toughness: {Toughness: 4%}
          Vitality: {Vitality: 4%}
          Concentration: {Concentration: 4%}
          Condition Damage: {Condition Damage: 4%}
          Expertise: {Expertise: 4%}
          Ferocity: {Ferocity: 4%}
          Healing Power: {Healing Power: 4%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-9
      text: Empowered Empowerment
      subText: 9 stacks
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '9'
      modifiers:
        conversion:
          Power: {Power: 4.5%}
          Precision: {Precision: 4.5%}
          Toughness: {Toughness: 4.5%}
          Vitality: {Vitality: 4.5%}
          Concentration: {Concentration: 4.5%}
          Condition Damage: {Condition Damage: 4.5%}
          Expertise: {Expertise: 4.5%}
          Ferocity: {Ferocity: 4.5%}
          Healing Power: {Healing Power: 4.5%}
      gw2id: 2241
      defaultEnabled: false
      temporaryBuff: true

    - id: empowered-empowerment-10
      text: Empowered Empowerment
      subText: 10 stacks
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: elemental-empowerment
            group: '10'
      modifiers:
        conversion:
          Power: {Power: 10%}
          Precision: {Precision: 10%}
          Toughness: {Toughness: 10%}
          Vitality: {Vitality: 10%}
          Concentration: {Concentration: 10%}
          Condition Damage: {Condition Damage: 10%}
          Expertise: {Expertise: 10%}
          Ferocity: {Ferocity: 10%}
          Healing Power: {Healing Power: 10%}
      gw2id: 2241
      defaultEnabled: true
      temporaryBuff: true

- section: Evoker
  id: 80
  items:

    - id: familiar-passive-hare
      subText: 'Familiar Passive: Hare, with fury'
      modifiers:
        attributes:
          Ferocity: [75, buff]
      wvwModifiers:
        attributes:
          Ferocity: [120, buff]
      minor: true
      defaultEnabled: false
      temporaryBuff: true

    - id: familiar-active-hare
      subText: 'Familiar Active: Hare'
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Critical Damage: [3%, unknown]
      wvwModifiers:
        damage:
          Outgoing Critical Damage: [5%, unknown]
      minor: true
      defaultEnabled: false
      temporaryBuff: true

    - id: fiery-might
      text: Fiery Might
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
      gw2id: 2391
      defaultEnabled: true

    - id: enhanced-potency-fox
      text: Enhanced Potency
      subText: fox
      minor: true
      amountData:
        label: 'might'
        default: 25
        quantityEntered: 1
      modifiers:
        attributes:
          Condition Damage: [5, buff]
      wvwModifiers:
        attributes:
          Condition Damage: [10, buff]
      gw2id: 2382
      defaultEnabled: false
      temporaryBuff: true

    - id: enhanced-potency-hare
      text: Enhanced Potency
      subText: hare, with fury
      minor: true
      modifiers:
        attributes:
          Critical Chance: 15%
      wvwModifiers:
        attributes:
          Critical Chance: 10%
      gw2id: 2382
      defaultEnabled: false
      temporaryBuff: true

    - id: familiars-focus-fox
      text: Familiar's Focus
      subText: fox
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Condition Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing Condition Damage: [20%, add]
      gw2id: 2342
      defaultEnabled: false

    - id: familiars-focus-hare
      text: Familiar's Focus
      subText: hare
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [20%, add]
      gw2id: 2342
      defaultEnabled: false

    - id: familiars-prowess-fox
      text: Familiar's Prowess
      subText: fox, without Familiar's Focus
      minor: true
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Condition Damage: [7%, add]
      gw2id: 2351
      defaultEnabled: false

    - id: familiars-prowess-hare
      text: Familiar's Prowess
      subText: hare, without Familiar's Focus
      minor: true
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, add]
      gw2id: 2351
      defaultEnabled: false
